export enum Page {
  HOLDING = '/frontend/link-shield/holding',
  BRAND_LINK = '/link/*',
}
